export const images = [
  "../assets/startThumbs/1.webp",
  "../assets/startThumbs/2.webp",
  "../assets/startThumbs/3.webp",
  "../assets/startThumbs/4.webp",
  "../assets/startThumbs/5.webp",
  "../assets/startThumbs/6.webp",
  "../assets/startThumbs/7.webp",
  "../assets/startThumbs/8.webp",
  "../assets/startThumbs/9.webp",
  "../assets/startThumbs/10.webp",
  "../assets/startThumbs/11.webp",
  "../assets/startThumbs/12.webp",
  "../assets/startThumbs/13.webp",
  "../assets/startThumbs/14.webp",
  "../assets/startThumbs/15.webp",
  "../assets/startThumbs/16.webp",
  "../assets/startThumbs/17.webp",
  "../assets/startThumbs/18.webp",
  "../assets/startThumbs/19.webp",
  "../assets/startThumbs/20.webp",
  "../assets/startThumbs/21.webp",
  "../assets/startThumbs/22.webp",
  "../assets/startThumbs/23.webp",
  "../assets/startThumbs/24.webp",
  "../assets/startThumbs/26.webp",
  "../assets/startThumbs/27.webp",
  "../assets/startThumbs/28.webp",
  "../assets/startThumbs/29.webp",
  "../assets/startThumbs/30.webp",
  "../assets/startThumbs/31.webp",
  "../assets/startThumbs/32.webp",
  "../assets/startThumbs/33.webp",
  "../assets/startThumbs/34.webp",
  "../assets/startThumbs/35.webp",
];

export function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia?.("(pointer: coarse)")?.matches
  );
}

export function startAnimation({
  wrapperSelector,
  containerId,
  images,
  getSize,
  throttle = 110,
  lifetime = 1000,
}) {
  const wrapper = document.querySelector(wrapperSelector);
  const container = document.getElementById(containerId);
  if (!wrapper || !container || !Array.isArray(images) || images.length === 0) {
    return () => {};
  }

  let currentImage = 0;
  let lastMove = 0;

  const handleMouseMove = (e) => {
    const now = Date.now();
    if (now - lastMove < throttle) return;
    lastMove = now;

    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const size = typeof getSize === "function" ? getSize() : 60;

    const img = document.createElement("img");
    img.src = images[currentImage];
    img.className = "trail-item";
    img.style.width = `${size}px`;
    img.style.height = `${size}px`;
    img.style.left = `${x - size / 2}px`;
    img.style.top = `${y - size / 2}px`;
    img.loading = "lazy";

    container.appendChild(img);

    requestAnimationFrame(() => {
      img.style.opacity = "1";
    });

    setTimeout(() => img.remove(), lifetime);

    currentImage = (currentImage + 1) % images.length;
  };

  wrapper.addEventListener("mousemove", handleMouseMove, { passive: true });

  return () => {
    wrapper.removeEventListener("mousemove", handleMouseMove);
  };
}

export function startTouchAnimation({
  containerId,
  images,
  getSize,
  lifetime = 1500,
  loopDuration = 7, // Dauer eines Umlaufs in Sekunden
  spawnInterval = 200,
}) {
  const container = document.getElementById(containerId);
  if (!container || !Array.isArray(images) || images.length === 0)
    return () => {};

  let currentImage = 0;
  let startTime = null;
  let lastSpawn = 0;
  let animFrame;

  function getPointOnPath(t) {
    const width = container.offsetWidth;
    const height = container.offsetHeight;
    const size = typeof getSize === "function" ? getSize() : 60;

    const xAmplitude = (width - size) / 2;

    const x = width / 2 + Math.sin(t * 2 * Math.PI) * xAmplitude;

    // Y so wie vorher
    const y = height / 2 + (Math.sin(t * 4 * Math.PI) * height) / 4;

    return { x, y };
  }

  function placeImage(x, y) {
    const size = typeof getSize === "function" ? getSize() : 60;
    const img = document.createElement("img");
    img.src = images[currentImage];
    img.className = "trail-item";
    img.style.position = "absolute";
    img.style.width = `${size}px`;
    img.style.height = `${size}px`;
    img.style.left = `${x - size / 2}px`;
    img.style.top = `${y - size / 2}px`;
    img.style.opacity = "0";
    // img.style.transition = "opacity 0.3s, transform 0.3s";

    container.appendChild(img);

    requestAnimationFrame(() => {
      img.style.opacity = "1";
    });

    setTimeout(() => img.remove(), lifetime);

    currentImage = (currentImage + 1) % images.length;
  }

  function animate(now) {
    if (startTime === null) startTime = now;
    const elapsed = (now - startTime) / 1000; // Sekunden
    const t = (elapsed % loopDuration) / loopDuration; // Fortschritt 0–1

    // Nur alle X Millisekunden ein Bild erzeugen
    if (now - lastSpawn > spawnInterval) {
      const { x, y } = getPointOnPath(t);
      placeImage(x, y);
      lastSpawn = now;
    }

    animFrame = requestAnimationFrame(animate);
  }

  animFrame = requestAnimationFrame(animate);

  return () => cancelAnimationFrame(animFrame);
}

// export function startTouchAnimation({
//   containerId,
//   images,
//   getSize,
//   lifetime = null, // null = Bilder nicht automatisch löschen
//   scale = 1.3,
//   loopDuration = 5, // Sekunden für die komplette Runde
//   spawnInterval = 150, // Abstand der Bilder in ms
// }) {
//   const container = document.getElementById(containerId);
//   if (!container || !Array.isArray(images) || images.length === 0)
//     return () => {};

//   let currentImage = 0;
//   let startTime = null;
//   let lastSpawn = 0;
//   let animFrame;
//   let finished = false;

//   function getPointOnPath(t) {
//     const width = container.offsetWidth;
//     const height = container.offsetHeight;

//     // Kringel (∞-Form)
//     const x = width / 2 + (Math.sin(t * 2 * Math.PI) * width) / 3;
//     const y = height / 2 + (Math.sin(t * 4 * Math.PI) * height) / 4;

//     return { x, y };
//   }

//   function placeImage(x, y) {
//     const size = typeof getSize === "function" ? getSize() : 60;
//     const img = document.createElement("img");
//     img.src = images[currentImage];
//     img.className = "trail-item";
//     img.style.position = "absolute";
//     img.style.width = `${size}px`;
//     img.style.height = `${size}px`;
//     img.style.left = `${x - size / 2}px`;
//     img.style.top = `${y - size / 2}px`;
//     img.style.opacity = "0";
//     img.style.transform = `scale(0.8)`;
//     img.style.transition = "opacity 0.3s, transform 0.3s";

//     container.appendChild(img);

//     requestAnimationFrame(() => {
//       img.style.opacity = "1";
//       img.style.transform = `scale(${scale})`;
//     });

//     if (lifetime) {
//       setTimeout(() => img.remove(), lifetime);
//     }

//     currentImage = (currentImage + 1) % images.length;
//   }

//   function animate(now) {
//     if (finished) return;
//     if (startTime === null) startTime = now;
//     const elapsed = (now - startTime) / 1000; // Sekunden
//     const t = elapsed / loopDuration; // Fortschritt absolut, nicht modulo

//     if (t >= 1) {
//       finished = true;
//       return; // Animation stoppt, Bilder bleiben stehen
//     }

//     if (now - lastSpawn > spawnInterval) {
//       const { x, y } = getPointOnPath(t);
//       placeImage(x, y);
//       lastSpawn = now;
//     }

//     animFrame = requestAnimationFrame(animate);
//   }

//   animFrame = requestAnimationFrame(animate);

//   return () => cancelAnimationFrame(animFrame);
// }
